export const config = {
  useLogger: false,
  isMutable: true,
};

// http://router5.github.io/docs/router-options.html
export const routerOptions = {
  defaultRoute: "home",
};

export const initialRoutes = [
  // home
  {
    name: "home",
    path: "/",
  },
];
